var map = {
	"./account.svg": "lNpt",
	"./ai-book.svg": "1hHJ",
	"./alipay.svg": "3DrL",
	"./android.svg": "DfSc",
	"./arrows-dn.svg": "FZnD",
	"./arrows-left.svg": "dp53",
	"./arrows-right.svg": "sGpw",
	"./arrows-up.svg": "9n4a",
	"./back-home.svg": "diAY",
	"./book-city.svg": "jPa9",
	"./book-shelf.svg": "cB+X",
	"./category-bold.svg": "D9xq",
	"./category.svg": "3HFE",
	"./check-circle.svg": "qrlD",
	"./check.svg": "7ZS0",
	"./circle.svg": "5gjf",
	"./clear-circle.svg": "X63x",
	"./complete.svg": "PGk/",
	"./control.svg": "oiHZ",
	"./delete.svg": "Imjp",
	"./details.svg": "MIkI",
	"./discuss.svg": "fIiT",
	"./down.svg": "LHwD",
	"./font-minus.svg": "m9xa",
	"./font-plus.svg": "o1ia",
	"./found.svg": "RlNO",
	"./gesture-horizotal-dr.svg": "E/Sl",
	"./gesture-press.svg": "5yK6",
	"./gesture-up-down.svg": "usek",
	"./history.svg": "nTk5",
	"./huodong.svg": "+bD3",
	"./inform.svg": "jBgF",
	"./iphone.svg": "LvA3",
	"./like.svg": "JDw2",
	"./lock-small.svg": "0kAA",
	"./lock.svg": "FnAU",
	"./menu.svg": "dH9r",
	"./message-blue.svg": "Jqo0",
	"./message-square.svg": "oyUQ",
	"./message.svg": "G2zY",
	"./moments.svg": "b5eS",
	"./moon.svg": "Ux9W",
	"./more-level.svg": "i805",
	"./more-vertical.svg": "eIeF",
	"./paihang.svg": "qxYo",
	"./pause.svg": "mQwT",
	"./phone-small.svg": "bklJ",
	"./phone.svg": "7pRf",
	"./play-default.svg": "OTIP",
	"./play-icon.svg": "EDQM",
	"./play-red.svg": "7PX8",
	"./plus-blod.svg": "GBjZ",
	"./plus.svg": "f+Cd",
	"./present-code.svg": "pVGY",
	"./present.svg": "+HiA",
	"./qq.svg": "R2jY",
	"./read-setting.svg": "N5VT",
	"./reader.svg": "mLuo",
	"./reward.svg": "lr47",
	"./safety.svg": "uQOh",
	"./search.svg": "Bx0U",
	"./setting.svg": "Kttn",
	"./share.svg": "BDVe",
	"./shopping-car.svg": "1E01",
	"./sort.svg": "pr7m",
	"./special.svg": "TgGA",
	"./star-default.svg": "HPFA",
	"./star-half.svg": "d2eA",
	"./star.svg": "60zo",
	"./sun.svg": "ZJ0R",
	"./top.svg": "jE4f",
	"./up.svg": "S+/b",
	"./user.svg": "VdD3",
	"./view-off.svg": "EQL3",
	"./view.svg": "zjNx",
	"./vip.svg": "WRQj",
	"./weibo.svg": "v1uz",
	"./weixin.svg": "E+Kt",
	"./xueke.svg": "lsW7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 65